<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close :loading = "loading">
			<template #default>
				<div ref="logistictrace_custom_form"></div>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "$input",
					"field": "goodsName",
					"title": "商品名称",
					"value": null,					
					"props": {
						"readonly": true,
						"name": "cargotype"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "matchtype",
					"title": "匹配方式",
					"value": 1,
					"hidden": false,
					"options": [{
						"label":"自定义",
						"value":1
					},{
						"label":"亿企赢存货",
						"value":2
					}],
					"props": {
						"name": "cargotype"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},	
				{
					"type": "$emun",
					"field": "cargotype",
					"title": "开票品类",
					"value": null,
					"hidden": false,
					"props": {
						"name": "cargotype"
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "cargoname",
					"title": "开票名称",
					"value": null,
					"hidden": false,
					"options":[],
					"props": {
						"allowCreate":true
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
			],
			"option": {
				"form": {
					"labelWidth": "100px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			goodsUids: {
				default: () => {
					return []
				}
			},
			currentrow: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				loading:false,
				modal_model:false,
				modal_title: '开票配置',
				modal_width:400,
				modal_height:300,
				customcargoname:[],
				//yqdzcargoname:[]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			modal_init(){
				if(this.currentrow){
					this.sourceData = {
						cargotype:this.currentrow.cargotypeid,
						goodsName:this.currentrow.goodsName,						
					}
					if(this.goodsUids){
						this.sourceData.matchtype = 1
					}else{
						this.sourceData.matchtype = 2
					}
					//console.log(this.sourceData)
				}else{
					this.sourceData = null
				}
				// return new Promise((reslove)=>{
				// 	this.$api.invoice.getyqdzinventory().then(()=>{
				// 		console.log(formjson)
				// 		reslove()
				// 	})
				// })
				
				return new Promise((reslove)=>{
					this.$api.goods.getcargoname().then((res)=>{
						let options = res.map((item)=>{
							return {
								value:item,
								id:item
							}
						})
						this.customcargoname = options
						let formData = JSON.parse(JSON.stringify(formjson))
						let rule = formData.rule.rule
						// rule.forEach((item)=>{
						// 	if(item.field == 'cargoname'){
						// 		item.options = options
						// 	}
						// })
						let option = formData.rule.option
						option.el = this.$refs.logistictrace_custom_form
						this.fApi = this.$formCreate(rule, option)
						this.fApi.nextTick(() => {
							this.regestevent(rule)
							this.setFormData()		
						})
						this.$emit('show')
						reslove()
					})
				})
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
				
			},
			cargotypeChange(e){
				this.fApi.setValue('cargoname',null)
				let matchtype = this.fApi.getValue('matchtype')				
				let targetfield = formjson.rule.rule.find((item)=>{
					return item.field == 'cargoname'
				})
				if(!targetfield){
					return
				}
				if(matchtype!=2){
					this.fApi.removeField('cargoname')
					targetfield.options = this.customcargoname
					this.$nextTick(()=>{
						this.fApi.append(targetfield, 'cargotype')
					})
				}else{
					this.loading = true
					this.$api.invoice.getyqdzinventory({
						cargotype:window.systemMethods.getEmunValue('cargotype',e)
					}).then((res)=>{
						this.loading = false
						this.fApi.removeField('cargoname')
						let options = res.map((item)=>{
							return {
								value:item,
								id:item
							}
						})
						targetfield.options = options
						this.$nextTick(()=>{
							this.fApi.append(targetfield, 'cargotype')
						})
					},()=>{
						this.loading = false
					})
					
				}

			},
			matchtypeChange(){
				this.fApi.setValue('cargotype',null)
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}else{
					this.fApi.setValue('matchtype', 2)
				}
			},
			submit() {
				this.loading = true
				this.fApi.submit((formData)=>{
					let submitData = JSON.parse(JSON.stringify(formData))
					this.submitDataFormater(submitData)
					submitData.goodsUids = this.goodsUids
					if(submitData.goodsUids){
						this.$api.goods.updategoodsspu(submitData).then(()=>{
							this.loading = false
							this.$emit('submit',submitData)
							this.modal_cancel()
						})
					}else{
						this.loading = false
						this.$emit('submit',submitData)
						this.modal_cancel()
					}
				})
				//this.init()
			},
			modal_cancel() {
				this.fApi.resetFields()
				this.modal_model = false
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>